import { Box } from '@mui/material';
import loaderGif from 'src/assets/loader.gif';

export const Loader = () => <img width={120} src={loaderGif} alt={'loading'}/>

export const PageLoader =() => <Box display={'flex'} height={600} justifyContent={'center'} alignItems={'center'}>
<Loader/> 
</Box>

export { GlobalLoadingOverlay } from './GlobalLoadingOverlay';